import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SignupSuccess.module.scss';

interface SignupSuccessProps {
  email?: string;
  organizationName?: string;
}

const SignupSuccess: React.FC<SignupSuccessProps> = ({ email, organizationName }) => {
  const navigate = useNavigate();

//   useEffect(() => {
//     // Auto-redirect after 5 seconds
//     const timer = setTimeout(() => {
//       navigate('/dashboard');
//     }, 5000);

//     return () => clearTimeout(timer);
//   }, [navigate]);

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <div className={styles.successContainer}>
      <div className={styles.successCard}>
        <div className={styles.topBar}></div>
        
        <div className={styles.successContent}>
          <div className={styles.checkmarkCircle}>
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="32" cy="32" r="32" fill="#20A85D" />
              <path
                d="M27 35L22 30M27 35L42 20"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 30L16 36"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1 className={styles.successTitle}>Account creation successful!</h1>
          
          <p className={styles.successSubtitle}>
            Thanks for registering to our platform.
          </p>

          <div className={styles.verificationBox}>
            <h2 className={styles.verificationTitle}>Verify your email address</h2>
            <p className={styles.verificationText}>
              An email verification link has been sent to your email.
              <br />
              Please follow the link to verify your email.
            </p>
          </div>

          <button className={styles.continueBtn} onClick={handleContinue}>
            Continue to Login
          </button>

        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
